import { useState } from 'react';
import {
    generateDashboardUrl,
    appendAdminContextToDonorShieldUrl,
    hasValidAdminAuthContext,
    donorShieldUrlHasAdminContext,
    getAdminAuthContext,
    DONOR_SHIELD_OPEN_ERROR_USER_MESSAGE,
    logDonorShieldOpenFailure
} from '../services/donor-shield-api';
import { toast } from 'react-toastify';

export const useDonorShieldNavigation = () => {
    const [isGeneratingToken, setIsGeneratingToken] = useState(false);

    const navigateToDonorShield = async (watrRequestId: number, destinationPath: string = 'dashboard') => {
        if (!watrRequestId) {
            logDonorShieldOpenFailure('missing WATR request id', { watrRequestId, destinationPath });
            toast.error(DONOR_SHIELD_OPEN_ERROR_USER_MESSAGE);
            return;
        }

        if (isGeneratingToken) {
            return;
        }

        if (!hasValidAdminAuthContext()) {
            logDonorShieldOpenFailure('invalid admin auth context before generate-url', getAdminAuthContext());
            toast.error(DONOR_SHIELD_OPEN_ERROR_USER_MESSAGE);
            return;
        }

        setIsGeneratingToken(true);
        try {
            const response = await generateDashboardUrl(watrRequestId, destinationPath);

            if (response.success && response.data?.dashboardUrl) {
                let dashboardUrl = response.data.dashboardUrl;
                
                if (response.data.oneTimeToken) {
                    const url = new URL(dashboardUrl);
                    url.searchParams.set('otp', response.data.oneTimeToken);
                    dashboardUrl = url.toString();
                }

                try {
                    dashboardUrl = appendAdminContextToDonorShieldUrl(dashboardUrl);
                } catch (appendError) {
                    logDonorShieldOpenFailure('appendAdminContextToDonorShieldUrl failed', appendError);
                    toast.error(DONOR_SHIELD_OPEN_ERROR_USER_MESSAGE);
                    return;
                }

                if (!donorShieldUrlHasAdminContext(dashboardUrl)) {
                    logDonorShieldOpenFailure('dashboard URL missing admin query params', { dashboardUrl });
                    toast.error(DONOR_SHIELD_OPEN_ERROR_USER_MESSAGE);
                    return;
                }
                
                window.open(dashboardUrl, '_blank');
            } else {
                logDonorShieldOpenFailure('generate-url unsuccessful', response);
                toast.error(DONOR_SHIELD_OPEN_ERROR_USER_MESSAGE);
            }
        } catch (error) {
            logDonorShieldOpenFailure('unexpected error during DonorShield open', error);
            toast.error(DONOR_SHIELD_OPEN_ERROR_USER_MESSAGE);
        } finally {
            setIsGeneratingToken(false);
        }
    };

    return {
        navigateToDonorShield,
        isGeneratingToken
    };
};
